(() => {
  const SELECTOR = '[data-mbb-how-it-works-collections]';

  class MbbHowItWorksCollections {
    constructor(section) {
      if (!section || section.dataset.mbbCollectionsInitialized === 'true') return;

      this.section = section;
      this.items = [...section.querySelectorAll('[data-collections-reveal]')];
      this.reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      this.init();
    }

    init() {
      this.section.dataset.mbbCollectionsInitialized = 'true';

      if (
        this.reducedMotion ||
        !('IntersectionObserver' in window)
      ) {
        this.reveal();
        return;
      }

      this.observer = new IntersectionObserver(
        entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;

          this.reveal();
          this.observer.disconnect();
        },
        {
          threshold: 0.15,
          rootMargin: '0px 0px -8% 0px'
        }
      );

      this.observer.observe(this.section);
    }

    reveal() {
      this.section.classList.add('is-visible');

      this.items.forEach(item => {
        item.classList.add('is-visible');
      });
    }

    destroy() {
      this.observer?.disconnect();

      this.section.classList.remove('is-visible');
      this.items.forEach(item => item.classList.remove('is-visible'));

      delete this.section.dataset.mbbCollectionsInitialized;
    }
  }

  const getSections = root => {
    if (root.matches?.(SELECTOR)) return [root];

    return [...(root.querySelectorAll?.(SELECTOR) || [])];
  };

  const init = root => {
    getSections(root).forEach(section => {
      if (section.dataset.mbbCollectionsInitialized === 'true') return;

      section.mbbHowItWorksCollections =
        new MbbHowItWorksCollections(section);
    });
  };

  const start = () => init(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', event => {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', event => {
    getSections(event.target).forEach(section => {
      section.mbbHowItWorksCollections?.destroy();
      delete section.mbbHowItWorksCollections;
    });
  });
})();